export interface AuthSettings {
  cxoneHostname: string;
  clientId: string;
  redirectUri: string;
  state?: string;
}
